import { render, staticRenderFns } from "./tipoRegistro.vue?vue&type=template&id=1f9b680c&scoped=true"
import script from "./tipoRegistro.vue?vue&type=script&lang=js"
export * from "./tipoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b680c",
  null
  
)

export default component.exports